module.exports = {
	"_args": [
		[
			{
				"name": "babel-core",
				"raw": "babel-core@^6",
				"rawSpec": "^6",
				"scope": null,
				"spec": ">=6.0.0 <7.0.0",
				"type": "range"
			},
			"/home/jan/workspace/lively4/lively4-kernel"
		]
	],
	"_from": "babel-core@>=6.0.0 <7.0.0",
	"_id": "babel-core@6.10.4",
	"_inCache": true,
	"_installable": true,
	"_location": "/babel-core",
	"_nodeVersion": "5.9.0",
	"_npmOperationalInternal": {
		"host": "packages-12-west.internal.npmjs.com",
		"tmp": "tmp/babel-core-6.10.4.tgz_1466527417705_0.10249125026166439"
	},
	"_npmUser": {
		"email": "loganfsmyth@gmail.com",
		"name": "loganfsmyth"
	},
	"_npmVersion": "3.9.3",
	"_phantomChildren": {},
	"_requested": {
		"name": "babel-core",
		"raw": "babel-core@^6",
		"rawSpec": "^6",
		"scope": null,
		"spec": ">=6.0.0 <7.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"/",
		"/babel-cli",
		"/babel-plugin-transform-regenerator",
		"/babel-register"
	],
	"_resolved": "https://registry.npmjs.org/babel-core/-/babel-core-6.10.4.tgz",
	"_shasum": "283f2212bb03d4e5cd7498b9886efbf6fc2e238e",
	"_shrinkwrap": null,
	"_spec": "babel-core@^6",
	"_where": "/home/jan/workspace/lively4/lively4-kernel",
	"author": {
		"email": "sebmck@gmail.com",
		"name": "Sebastian McKenzie"
	},
	"dependencies": {
		"babel-code-frame": "^6.8.0",
		"babel-generator": "^6.9.0",
		"babel-helpers": "^6.8.0",
		"babel-messages": "^6.8.0",
		"babel-register": "^6.9.0",
		"babel-runtime": "^6.9.1",
		"babel-template": "^6.9.0",
		"babel-traverse": "^6.10.4",
		"babel-types": "^6.9.1",
		"babylon": "^6.7.0",
		"convert-source-map": "^1.1.0",
		"debug": "^2.1.1",
		"json5": "^0.4.0",
		"lodash": "^4.2.0",
		"minimatch": "^3.0.2",
		"path-exists": "^1.0.0",
		"path-is-absolute": "^1.0.0",
		"private": "^0.1.6",
		"shebang-regex": "^1.0.0",
		"slash": "^1.0.0",
		"source-map": "^0.5.0"
	},
	"description": "Babel compiler core.",
	"devDependencies": {
		"babel-helper-fixtures": "^6.9.0",
		"babel-helper-transform-fixture-test-runner": "^6.9.0",
		"babel-polyfill": "^6.9.1"
	},
	"directories": {},
	"dist": {
		"shasum": "283f2212bb03d4e5cd7498b9886efbf6fc2e238e",
		"tarball": "https://registry.npmjs.org/babel-core/-/babel-core-6.10.4.tgz"
	},
	"homepage": "https://babeljs.io/",
	"keywords": [
		"6to5",
		"babel",
		"classes",
		"const",
		"es6",
		"harmony",
		"let",
		"modules",
		"transpile",
		"transpiler",
		"var"
	],
	"license": "MIT",
	"maintainers": [
		{
			"email": "amjad.masad@gmail.com",
			"name": "amasad"
		},
		{
			"email": "hi@henryzoo.com",
			"name": "hzoo"
		},
		{
			"email": "npm-public@jessemccarthy.net",
			"name": "jmm"
		},
		{
			"email": "loganfsmyth@gmail.com",
			"name": "loganfsmyth"
		},
		{
			"email": "sebmck@gmail.com",
			"name": "sebmck"
		},
		{
			"email": "me@thejameskyle.com",
			"name": "thejameskyle"
		}
	],
	"name": "babel-core",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "https://github.com/babel/babel/tree/master/packages/babel-core"
	},
	"scripts": {
		"bench": "make bench",
		"test": "make test"
	},
	"version": "6.10.4"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/package.json
 ** module id = 493
 ** module chunks = 0
 **/